module.exports = __webpack_public_path__ + "img/ComicNeueSansID.2ca2f4a8.svg";